import style from '../portfolio-items.module.css'
import Carousel from './embla-carousel/bnkazov-embla.jsx'
import Portfolio from '../../../main/portfolio.jsx'
import ContactForm from '../../../main/contactForm.jsx'
import HireUs from '../../../forIndustrial/hireUs.jsx'

const OPTIONS = {}

export default function Bnkazov(props) {
    return (
        <div className={style.wrapper}>
            <div className={style.container}>
                <h1><span style={{color: '#ff8c00'}}>Работы по сборке оборудования</span><br /> для нужд завода ООО «БНК» (аутстаффинг)</h1>
                <Carousel options={OPTIONS} />
                <div className={style.description}>
                    <div className={style.tasks}>
                        <h6>Задача:</h6>
                        <p>Повысить скорость и качество выпуска готовой продукции за счёт привлечения квалифицированного персонала.</p>
                    </div>
                    <div className={style.specification}>
                        <div сlassName={style.info}>
                            <p><strong>Заказчик: </strong>ООО «БНК».</p>
                            <p><strong>Дата: </strong>май - октябрь 2025 г.</p>
                            <p><strong>Срок выполнения: </strong>100 рабочих дней.</p>
                            <h3 className={style.results}>Результаты работ:</h3>
                            <ul>
                                <li>Обеспечена поддержка завода-изготовителя в сборке фотоэлектрических инверторов UG-2500-600-PHV.</li>
                                <li>Выполнена комплектная сборка БКТП, включая установку оборудования, распределительных ячеек и шкафов связи.</li>
                                <li>Повышена скорость и качество выпуска готовой продукции за счёт привлечения квалифицированного персонала.</li>
                            </ul>
                        </div>
                        <div className={style.solution}>
                            <h3>Решения для проекта:</h3>
                            <ul>
                                <li>Произведена сборка партии инверторов UG-2500-600-PHV (монтаж силового оборудования, защитных панелей).</li>
                                <li>Выполнена сборка БКТП.</li>
                                <li>Проведена финальная сборка и проверка узлов смонтированного оборудования.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <HireUs />
            <Portfolio />
            <div style={{height: '2rem'}}></div>
            <ContactForm />
        </div>
    )
}